<template>
<transition name="slide-fade">
    <div class="dialog-view" v-show="visible">        
        <div class="map-modal u-window">           
            <div class="dialog-content">              
                <div class="u-btn close" @click="destroyElement"></div>
                <div class="dialog-wrapper">
                    <div class="dialog-title t-map"></div>
                    <ul>
                        <li v-for="(item,index) in map_data" :key="'map-' + index">
                            <em class="index">{{ item.tag }}</em>
                            <span>{{ item.name }}</span>
                        </li>
                    </ul>
                    <div class="u-btn ok" @click="destroyElement"></div>
                </div>
            </div>
        </div> 
        <div class="u-mask"></div>
    </div>
</transition>    
</template>

<script>
export default {
    name : 'map_modal',
    data : function () {
        return {
            visible : false,
            map_data : [
            {
                'tag' : 'A',
                'name' : '军团出征'
            },
            {
                'tag' : 'B',
                'name' : '军团出征巅峰'
            },
            {
                'tag' : 'C',
                'name' : '娱乐三国无双'
            },
            {
                'tag' : 'D',
                'name' : '天命荆州争霸'
            },
            {
                'tag' : 'E',
                'name' : '英霸官渡'
            },
            {
                'tag' : 'F',
                'name' : '英霸三国无双'
            },                                                            
            ],          
        }
    },
    watch: {
        closed (newVal) {
            if (newVal) {
                this.visible = false
                this.destroyElement()
            }
        }
    },
    methods: {
        destroyElement () {
            this.$destroy()
            this.$el.parentNode.removeChild(this.$el)
        },
    }    
}
</script>

<style scoped>

@media screen and (min-device-width: 1025px){
    .map-modal{
        width: 469px;
        height: 381px;
        background-image: url(../../images/bg-modal-map.png);
    }

    .t-map{
        width: 320px;
        height: 73px;
        margin: 0 auto 20px;
        background-image: url(../../images/title-map.png);
    }

    .map-modal .dialog-wrapper{
        padding: 40px 40px 0;
    }    

    .map-modal .index{
        display: block;
        position: absolute;
        left: 0;
        top: 0;
        width: 27px;
        height: 27px;
        line-height: 27px;
        background-image: url(../../images/bg-index.png);
        color: #e6dac0;
        font-weight: 700;
        text-align: center;
    }

    .map-modal ul{
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        margin-left: 52px;
        margin-bottom: 35px;
        margin-top: 30px;
    }

    .map-modal li{
        position: relative;
        display: inline-block;
        width: 50%;
        padding-left: 35px;
        vertical-align: middle;
        margin-bottom: 10px;
        color: #63544b;
        box-sizing: border-box;
    }

    .u-btn.ok{
        width: 166px;
        height: 49px;
        margin: 25px auto 0;
        background-image: url(../../images/btn-iknow.png);    
    }
    
    .u-btn.ok:hover{
        background-image: url(../../images/btn-iknow_hover.png);   
    }  
}

@media screen and (max-device-width: 1024px){
    .map-modal{
        width: 609px;
        height: 411px;
        background-image: url(../../images/m/bg-modal-map.png);
    }

    .t-map{
        width: 384px;
        height: 79px;
        margin: 0 auto 20px;
        background-image: url(../../images/m/title-map.png);
    }

    .map-modal .dialog-wrapper{
        padding: 40px 40px 0;
    }    

    .map-modal .index{
        display: block;
        position: absolute;
        left: 0;
        top: -5px;
        width: 43px;
        height: 43px;
        line-height: 43px;
        background-image: url(../../images/m/bg-index.png);
        color: #e6dac0;
        font-weight: 700;
        text-align: center;
    }

    .map-modal ul{
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        margin-left: 52px;
        margin-bottom: 35px;
        margin-top: 30px;
    }

    .map-modal li{
        position: relative;
        display: inline-block;
        width: 50%;
        padding-left: 50px;
        vertical-align: middle;
        margin-bottom: 10px;
        color: #63544b;
        box-sizing: border-box;
    }

    .u-btn.ok{
        width: 218px;
        height: 65px;
        margin: 25px auto 0;
        background-image: url(../../images/m/btn-iknow.png);   
    }
      
}
   
</style>


// WEBPACK FOOTER //
// src/components/MapModal/mapModal.vue